function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();

    console.log(this);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (
      !openDetailsElement ||
      openDetailsElement.getAttribute("disabled") !== null
    )
      return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    // Close all other open menus
    document.querySelectorAll("details[open]").forEach((openDetails) => {
      if (openDetails !== detailsElement) {
        openDetails.removeAttribute("open");
        openDetails.classList.remove("menu-opening");
        openDetails
          .querySelector("summary")
          .setAttribute("aria-expanded", false);
      }
    });

    if (isOpen) {
      // If the clicked menu is already open, close it
      detailsElement.removeAttribute("open");
      detailsElement.classList.remove("menu-opening");
      summaryElement.setAttribute("aria-expanded", false);
    } else {
      // Otherwise, open the clicked menu
      detailsElement.setAttribute("open", true);
      detailsElement.classList.add("menu-opening");
      summaryElement.setAttribute("aria-expanded", true);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section.section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class GaiaHeader extends HTMLElement {
  constructor() {
    super();

    let gaiaHeader = this;

    window.addEventListener("scroll", () => {
      let headerRect = gaiaHeader.getBoundingClientRect();
      let headerPos = 0;
      if (window.scrollY > this.previousScroll) {
        // scrolling down
        headerPos = 0 - headerRect.height;
      } else {
        // scrolling up
      }
      this.style.top = `${headerPos}px`;
      this.previousScroll = window.scrollY;
    });

    this.addEventListener("click", () => {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.getBoundingClientRect().bottom)}px`
      );
    });
  }
}

customElements.define("gaia-header", GaiaHeader);

class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("summary + *");

    this.details.classList.add("closed");

    if (this.content.getAttribute("tabindex") === null)
      this.content.setAttribute("tabindex", "0");

    this.summary.addEventListener("click", (e) => {
      this.click(e);
    });

    this.clickOffListener = this.clickOff.bind(this);
  }

  clickOff(e) {
    if (this.details.open && !this.contains(e.target)) {
      this.close();
    }
  }

  click(e) {
    e.preventDefault();
    if (
      this.details.open ||
      this.details.classList.contains("opening") ||
      this.details.classList.contains("open")
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      let ariaLabel = detailsElement.getAttribute("aria-label") || "";
      if (detailsElement.hasAttribute("open")) {
        ariaLabel = ariaLabel.replace("Open", "Close");
      } else {
        ariaLabel = ariaLabel.replace("Close", "Open");
      }
      detailsElement.setAttribute("aria-label", ariaLabel);
    }
  }

  open() {
    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    if (!this.closest("details"))
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    setTimeout(() => {
      this.details.classList.remove("opening");
      this.details.classList.add("open");
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    }, 300);

    this.updateAriaLabel();
    document.addEventListener("click", this.clickOffListener);
  }

  close() {
    this.details.classList.remove("open");
    this.details.classList.remove("opening");
    this.details.classList.add("closing");
    if (!this.closest("details"))
      document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.classList.remove("closing");
      this.details.classList.add("closed");
    }, 300);
    document.removeEventListener("click", this.clickOffListener);
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-dropdown", GaiaDropdown);

// Get the card to take the height of the longest menu element
function adjustMegaMenuCardHeight() {
  const megaMenus = document.querySelectorAll(".mega-menu");

  megaMenus.forEach((menu) => {
    // Find all <li> elements wrapping the grandchild-menu
    const grandchildMenuItems = Array.from(
      menu.querySelectorAll(".grandchild-menu")
    ).map((grandchildMenu) => grandchildMenu.closest("li"));

    const megaMenuCards = menu.querySelectorAll(".mega-menu-card");

    if (grandchildMenuItems.length > 0 && megaMenuCards.length > 0) {
      let tallestHeight = 0;

      // Find the tallest <li> wrapping the grandchild-menu
      grandchildMenuItems.forEach((grandchildMenuItem) => {
        if (grandchildMenuItem) {
          const height = grandchildMenuItem.offsetHeight;
          if (height > tallestHeight) {
            tallestHeight = height;
          }
        }
      });

      // Apply the tallest height to all mega-menu-cards
      megaMenuCards.forEach((card) => {
        card.style.height = `${tallestHeight}px`;
      });
    }
  });
}
// Recalculate heights on resize
window.addEventListener("resize", adjustMegaMenuCardHeight);
// Recalculate heights on load
document.addEventListener("DOMContentLoaded", adjustMegaMenuCardHeight);

document.addEventListener("DOMContentLoaded", () => {
  // Focus search input when search is opened
  const searchDropdowns = document.querySelectorAll(
    ".menu-search gaia-dropdown"
  );
  searchDropdowns.forEach((searchDropdown) => {
    const searchInput = searchDropdown.querySelector("input.search__input");

    if (searchDropdown && searchInput) {
      const summaryElement = searchDropdown.querySelector("summary");

      if (summaryElement) {
        summaryElement.addEventListener("click", () => {
          setTimeout(() => {
            searchInput.focus();
          }, 0); // Delay to ensure the dropdown is fully open before focusing
        });
      }
    }
  });
  // Search close
  const closeButtons = document.querySelectorAll(".close__button");
  closeButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const dropdown = button.closest("gaia-dropdown");
      if (dropdown) {
        const details = dropdown.querySelector("details");
        if (details && details.hasAttribute("open")) {
          details.removeAttribute("open");
          details.classList.remove("open");
          details.classList.add("closed");
        }
      }
    });
  });
});
